export const getAppUrl = (): string => {
  if (process.env.APP_DOMAIN.startsWith('localhost')) {
    return `http://${process.env.APP_DOMAIN}`;
  }

  return `https://${process.env.APP_DOMAIN}`;
};
